import { z } from 'zod';
import { agencySchema } from './agency.js';
import { bankSchema } from './bank.js';
import { cisAssessmentSchema } from './cis-assessment.js';
import { cisVerificationResultSchema } from './cis-verification.js';
import { documentsSchema } from './documents.js';
import { occupationSchema } from './occupation.js';
import { paymentSchema } from './payment.js';
import { personalDetailsSchema } from './personal-details.js';
import { referralSchema } from './referral.js';
import { utrSchema } from './utr.js';

const base = {
  personal: personalDetailsSchema,
  referral: referralSchema,
  agency: agencySchema,
  bank: bankSchema,
  payment: paymentSchema,
  documents: documentsSchema,
  declarationAccepted: z
    .boolean()
    .refine((v) => v === true, 'You must confirm the final declaration'),
};

export const registrationSchema = z.discriminatedUnion('cis', [
  z.object({
    cis: z.literal(false),
    ...base,
    occupation: occupationSchema.extend({ cis: z.literal(false) }),
  }),
  z.object({
    cis: z.literal(true),
    ...base,
    occupation: occupationSchema.extend({ cis: z.literal(true) }),
    utr: utrSchema,
    cisAssessment: cisAssessmentSchema,
    // optional: an unverified / unmatched applicant can still submit (treated as 30%).
    cisVerification: cisVerificationResultSchema.optional(),
  }),
]);

export type Registration = z.infer<typeof registrationSchema>;
export type RegistrationNonCis = Extract<Registration, { cis: false }>;
export type RegistrationCis = Extract<Registration, { cis: true }>;
